import { GrandirUKTheme as GrandirUKMFTheme } from '@famly/mf_theme';
import { hexToRGBA } from 'web-app/util/hex-to-rgb';
import BaseTheme from './base';
const GrandirUKChromeColor = '#495940';
const GrandirUKPrimary = GrandirUKChromeColor;
const GrandirUKActive = hexToRGBA(GrandirUKChromeColor, 0.8);
const GrandirUKBackgroundHover = hexToRGBA(GrandirUKChromeColor, 0.04);
const GrandirUKTheme = {
    ...BaseTheme,
    title: 'GrandirUK',
    chromeColor: GrandirUKChromeColor,
    primary: GrandirUKPrimary,
    active: GrandirUKActive,
    backgroundHover: GrandirUKBackgroundHover,
    mf: GrandirUKMFTheme,
};
export default GrandirUKTheme;
